// root parameter limits init to a specific gallery container (e.g. after a DOM swap).
// Callers that omit root get document — same behaviour as before.
const sliderInit = (isUpdate, root = document) => {
	const mediaLists = root.querySelectorAll('.js-media-list')
	if (!mediaLists.length) return

	mediaLists.forEach((elem, index) => {
		// skip already-initialised instances (caller must destroy first if a reinit is needed)
		if (elem.swiper) return

		let prevButton = elem
			.closest('.product')
			?.querySelector('.product__slider-nav .swiper-button-prev')
		let nextButton = elem
			.closest('.product')
			?.querySelector('.product__slider-nav .swiper-button-next')

		// Match sub-slider by index within the same root so thumbs stay scoped.
		const sublistInRoot = root.querySelectorAll('.js-media-sublist')[index]

		let slider = new Swiper(elem, {
			slidesPerView: 1,
			spaceBetween: 1,
			mousewheel: {
				forceToAxis: true,
			},
			autoHeight: false,
			speed: 500,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			pagination: {
				el:
					elem.closest('.product')?.querySelector('.product__pagination') ||
					'.product .product__pagination',
				type: 'bullets',
				clickable: true,
			},
			thumbs: {
				swiper: sublistInRoot?.swiper || '',
			},
			on: {
				afterInit: function () {},
				slideChangeTransitionStart: function () {
					if (sublistInRoot?.swiper) {
						sublistInRoot.swiper.slideTo(this.activeIndex ?? 0)
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false

					const popup = document.querySelector('.js-popup-slider')
					if (popup?.swiper) {
						popup.swiper.slideTo(this.activeIndex)
					}
				},
				slideChangeTransitionEnd: function () {
					const slide = this.slides?.[this.activeIndex]
					if (slide?.querySelector('model-viewer')) {
						slide
							.querySelector('.shopify-model-viewer-ui__button--poster')
							?.removeAttribute('hidden')
					}
				},
				touchStart: function () {
					const slide = this.slides?.[this.activeIndex]
					if (slide?.querySelector('model-viewer')) {
						if (
							!slide
								.querySelector('model-viewer')
								.classList.contains('shopify-model-viewer-ui__disabled')
						) {
							this.params.noSwiping = true
							this.params.noSwipingClass = 'swiper-slide'
						} else {
							this.params.noSwiping = false
						}
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				slider.update()
			}, 800)
		}
	})
}

const subSliderInit = (isUpdate, margin, root = document) => {
	const sublists = root.querySelectorAll('.js-media-sublist')
	if (sublists.length > 0) {
		sublists.forEach((elem) => {
			if (elem.swiper) return
			const slides = elem.querySelectorAll('.product__media-subitem')
			const slidesAmount = slides.length
			const slidesPerView = Math.min(slidesAmount, 5)
			let subSlider = new Swiper(elem, {
				slidesPerView: slidesPerView,
				spaceBetween: 8,
				direction: 'horizontal',
				mousewheel: {
					forceToAxis: true,
				},
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				on: {
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				breakpoints: {
					1100: {
						spaceBetween: margin,
						slidesPerView: slidesPerView,
					},
				},
			})

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	if (document.querySelector('.js-popup-slider')) {
		let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
			slidesPerView: 1,
			mousewheel: {
				forceToAxis: true,
			},
			zoom: {
				maxRatio: 2,
			},
			navigation: {
				nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
				prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
			},
			pagination: {
				el: '.product-media-modal .product__pagination',
				type: 'bullets',
				clickable: true,
			},
			on: {
				afterInit: function () {
					if (
						document.querySelector('.product__outer--grid-gallery') ||
						document.querySelector('.product__outer--stacked-gallery')
					) {
						document
							.querySelectorAll('.product__media-list .product__media-toggle')
							.forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document
											.querySelector('.js-popup-slider')
											.swiper.slideTo(index)
									}
								})
							})
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false
					document
						.querySelector('.product-media-modal__content')
						?.classList.remove('zoom')
				},
				touchMove: function () {
					document
						.querySelector('.product-media-modal__content')
						?.classList.remove('zoom')
				},
				slideChangeTransitionEnd: function () {
					const slide = this.slides?.[this.activeIndex]
					if (slide?.querySelector('model-viewer')) {
						slide
							.querySelector('.shopify-model-viewer-ui__button--poster')
							?.removeAttribute('hidden')
					}
				},
				touchStart: function () {
					const slide = this.slides?.[this.activeIndex]
					if (slide?.querySelector('model-viewer')) {
						if (
							!slide
								.querySelector('model-viewer')
								.classList.contains('shopify-model-viewer-ui__disabled')
						) {
							this.params.noSwiping = true
							this.params.noSwipingClass = 'swiper-slide'
						} else {
							this.params.noSwiping = false
						}
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update()
			}, 800)
		}
	}
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute(
			'content',
			'width=device-width, initial-scale=1, maximum-scale=1',
		)
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	)
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open'),
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*',
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => {
		if (!video.closest('.hero__image') && !video.closest('.multirow__video'))
			video.pause()
	})
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused'))
		elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', {bubbles: true})

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ''
				) {
					e.currentTarget.value
				} else {
					e.currentTarget.value = 1
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
					this.previousElementSibling.classList.add('disabled')
				} else {
					this.previousElementSibling.classList.remove('disabled')
				}
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}
		})
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add('disabled')
		} else {
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()
	}
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(
		options['hideElement'] || province_domid,
	)

	Shopify.addListener(
		this.countryEl,
		'change',
		Shopify.bind(this.countryHandler, this),
	)

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

const body = document.body
let bodyScrollTop = null
let locked = false

function getScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth
}

function preventScroll(e) {
	e.preventDefault()
}

function lockScroll() {
	bodyScrollTop =
		typeof window.pageYOffset !== 'undefined'
			? window.pageYOffset
			: (document.documentElement || document.body.parentNode || document.body)
					.scrollTop

	var scrollBarWidth = getScrollbarWidth()
	body.style.paddingRight = scrollBarWidth + 'px'

	body.classList.add('scroll-locked')
	locked = true

	document.addEventListener('scroll', preventScroll, {passive: false})
}

function unlockScroll() {
	body.classList.remove('scroll-locked')
	body.style.paddingRight = ''
	window.scrollTo(0, bodyScrollTop)

	document.removeEventListener('scroll', preventScroll)
}

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty(
				'--viewport-height',
				`${window.innerHeight}px`,
			)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this)),
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button)
				return
			if (button.classList.contains('mobile-facets__footer__button')) return

			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector('button'),
			)

			setTimeout(() => {
				detailsElement.classList.add('menu-opening')
			})
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle
				.querySelector('summary')
				.setAttribute('aria-expanded', false)
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`,
			)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header =
				this.header || document.querySelector('.shopify-section-header')
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer()
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary'),
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.headerWrapper = document.querySelector('.header-wrapper')
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.headerWrapper.getBoundingClientRect().top)}px`,
		)
		const main = document.querySelector('main')
		if (
			main
				.querySelectorAll('.shopify-section')[0]
				?.classList.contains('section--has-overlay')
		) {
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
}

customElements.define('header-drawer', HeaderDrawer)

class LocalizationForm extends HTMLElement {
	constructor() {
		super()
		this.elements = {
			input: this.querySelector(
				'input[name="locale_code"], input[name="country_code"]',
			),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		}

		this.handleDocumentClick = this.handleDocumentClick.bind(this)
		this.elements.button.addEventListener('click', this.togglePanel.bind(this))
		this.addEventListener('keydown', this.onEscapePress.bind(this))

		this.querySelectorAll('a').forEach((item) =>
			item.addEventListener('click', this.onItemClick.bind(this)),
		)
	}

	connectedCallback() {
		document.addEventListener('click', this.handleDocumentClick)
	}

	disconnectedCallback() {
		document.removeEventListener('click', this.handleDocumentClick)
	}

	handleDocumentClick(event) {
		if (!this.contains(event.target)) {
			this.hidePanel()
		}
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false')
		this.elements.panel.setAttribute('hidden', true)
	}

	showPanel() {
		this.elements.button.setAttribute('aria-expanded', 'true')
		this.elements.panel.removeAttribute('hidden')
	}

	togglePanel() {
		if (this.elements.button.getAttribute('aria-expanded') === 'true') {
			this.hidePanel()
		} else {
			this.showPanel()
		}
	}

	onEscapePress(event) {
		if (event.key === 'Escape') {
			this.hidePanel()
		}
	}

	onItemClick(event) {
		event.preventDefault()
		this.elements.input.value = event.currentTarget.dataset.value
		this.querySelector('form')?.submit()
		this.hidePanel()
	}
}

customElements.define('localization-form', LocalizationForm)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			'click',
			this.hide.bind(this, false),
		)
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (
					event.pointerType === 'mouse' &&
					!event.target.closest('deferred-media, product-model')
				)
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()

		if (
			/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
			this.classList.contains('product-media-modal')
		) {
			lockScroll()
		}
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden')
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}

		const images = document.querySelector('.product-media-modal__content')

		if (images) {
			images.classList.remove('zoom')
		}

		if (
			/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
			this.classList.contains('product-media-modal')
		) {
			unlockScroll()
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this),
		)
		if (this.getAttribute('data-autoplay')) {
			this.loadContent()
		}
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(
				this.querySelector('template').content.firstElementChild.cloneNode(
					true,
				),
			)

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			/*this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			).focus();*/

			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute('data-autoplay')) {
							if (deferredElement.nodeName == 'VIDEO') {
								let playPromise = entry.target.play()
								if (playPromise !== undefined) {
									playPromise.then((_) => {}).catch((error) => {})
								}
							} else {
								if (entry.target.classList.contains('js-youtube')) {
									entry.target.contentWindow.postMessage(
										'{"event":"command","func":"' +
											'playVideo' +
											'","args":""}',
										'*',
									)
								} else {
									entry.target.contentWindow.postMessage(
										'{"method":"play"}',
										'*',
									)
								}
							}
							//entry.target.play()
						}
					} else {
						if (deferredElement.nodeName == 'VIDEO') {
							entry.target.pause()
						} else {
							if (entry.target.classList.contains('js-youtube')) {
								entry.target.contentWindow.postMessage(
									'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
									'*',
								)
							} else {
								entry.target.contentWindow.postMessage(
									'{"method":"pause"}',
									'*',
								)
							}
						}
					}
				})
			})

			const deferredElement = this.appendChild(
				content.querySelector('video, model-viewer, iframe'),
			)
			//if (focus) deferredElement.focus();

			if (
				deferredElement.nodeName == 'VIDEO' ||
				deferredElement.nodeName == 'IFRAME'
			) {
				// force autoplay for safari

				if (this.classList.contains('video-section__media')) {
					if (deferredElement.nodeName == 'VIDEO') {
						let playPromise = deferredElement.play()
						if (playPromise !== undefined) {
							playPromise.then((_) => {}).catch((error) => {})
						}
					}

					videoObserver.observe(deferredElement)
				} else {
					deferredElement.play()
				}
			}

			const swiperEl = this.closest('.swiper')
			const activeSlide =
				swiperEl?.swiper?.slides?.[swiperEl?.swiper?.activeIndex]
			if (activeSlide?.querySelector('model-viewer')) {
				if (
					!activeSlide
						.querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					swiperEl.swiper.params.noSwiping = true
					swiperEl.swiper.params.noSwipingClass = 'swiper-slide'
				}
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)

		this.isHighVariantNeedUpdate = false
		this.isCombinedListingsNeedUpdate = false
	}

	onVariantChange(event) {
		if (!this.contains(event.target)) return

		const combinedProductURL = this.resolveCombinedProductUrl(event.target)
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, '')

		this.isHighVariantNeedUpdate = false
		this.isCombinedListingsNeedUpdate = false

		// checking for high-variant and combined products
		// combinedProductURL check has no !currentVariant guard: the selected option may
		// exist in the current product's variant data (same option name, different product),
		// so we must detect the switch regardless of whether a local variant was found.
		if (
			(!this.currentVariant && this.dataset.isHighVariantProduct === 'true') ||
			combinedProductURL
		) {
			const selectedValuesIds = this.getSelectedValuesIds()
			this.highVariantRequestUrl = this.createRequestUrl({
				selectedValuesIds: selectedValuesIds,
				combinedProductURL: combinedProductURL,
			})
			if (this.highVariantRequestUrl) {
				this.isHighVariantNeedUpdate = true
				if (combinedProductURL) {
					this.isCombinedListingsNeedUpdate = true
				}
			}
		}

		if (!this.isHighVariantNeedUpdate) {
			this.updatePickupAvailability()
			this.updateVariantStatuses()
		}

		// For combined listing switches, always use the fetch path even when
		// currentVariant was resolved locally (its data belongs to the current product).
		if (!this.currentVariant || this.isCombinedListingsNeedUpdate) {
			if (this.isHighVariantNeedUpdate) {
				this.classList.add('high-variant-loading')
				this.renderProductInfo(this.highVariantRequestUrl)
				return
			}
			if (!this.currentVariant) {
				this.toggleAddButton(true, '')
				this.setUnavailable()
			}
		} else {
			if (
				this.currentVariant?.featured_media &&
				this.dataset?.variantMediaDisplay === 'show_all'
			) {
				this.updateMedia(
					`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				)
			}
			this.updateURL()
			this.updateVariantInput()
			const requestUrl = this.createRequestUrl({
				currentVariantId: this.currentVariant.id,
				selectedValuesIds: this.getSelectedValuesIds(),
			})
			this.renderProductInfo(requestUrl)
		}

		// VARIANT CHANGE EVENT
		if (this.currentVariant) {
			document.dispatchEvent(
				new CustomEvent('variant:change', {
					detail: {
						variant: this.currentVariant,
						previousVariant: this.previousVariant || null,
						formElement: document.querySelector(`#${this.getAttribute('id')}`),
						sectionId: this.dataset.section,
					},
				}),
			)

			// Save the previous version
			this.previousVariant = this.currentVariant
		}
	}

	/**
	 * Combined listings attach `data-product-url` on option radios.
	 * Dropdown UI dispatches `change` from the hidden field sync; resolve URL from the checked radio in the same fieldset.
	 */
	resolveCombinedProductUrl(eventTarget) {
		// Extract the product handle from a URL — robust against locale prefixes (/en/products/...).
		const extractHandle = (url) => {
			if (!url) return null
			const m = url.match(/\/products\/([^/?#]+)/)
			return m ? m[1] : null
		}
		const currentHandle = extractHandle(this.dataset.url || '')
		const isDifferentProduct = (url) => {
			if (!url) return false
			const handle = extractHandle(url)
			// if either handle is unresolvable, don't treat as combined switch
			if (!handle || !currentHandle) return false
			return handle !== currentHandle
		}

		const fromTarget = eventTarget?.dataset?.productUrl
		if (isDifferentProduct(fromTarget)) return fromTarget
		// native <select>: read data-product-url from the selected <option>
		if (eventTarget?.tagName === 'SELECT') {
			const selectedOpt = eventTarget.options[eventTarget.selectedIndex]
			if (isDifferentProduct(selectedOpt?.dataset?.productUrl))
				return selectedOpt.dataset.productUrl
		}
		const fieldset = eventTarget?.closest?.('.product-form__controls--dropdown')
		if (fieldset) {
			const checkedRadio = fieldset.querySelector('input[type="radio"]:checked')
			if (isDifferentProduct(checkedRadio?.dataset?.productUrl))
				return checkedRadio.dataset.productUrl
		}
		return ''
	}

	updateOptions() {
		const fieldsets = Array.from(
			this.querySelectorAll('.product-form__controls--dropdown'),
		)

		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value,
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll('input')).find(
					(radio) => radio.checked,
				)?.value
			}),
		)
	}

	getSelectedValuesIds() {
		const controls = [...this.querySelectorAll('.product-form__controls')]

		controls.sort((a, b) => {
			return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
		})

		return controls.map((control) => {
			const select = control.querySelector('select')
			if (select) {
				const selectedOption = select.options[select.selectedIndex]
				return (
					selectedOption?.dataset?.optionValueId ||
					selectedOption?.value ||
					null
				)
			}

			const checkedInput = control.querySelector('input[type="radio"]:checked')
			return checkedInput?.dataset?.optionValueId
				? checkedInput.dataset.optionValueId
				: null
		})
	}

	createRequestUrl({
		combinedProductURL = '',
		currentVariantId = '',
		selectedValuesIds = [],
	}) {
		const productUrl = combinedProductURL || `${this.dataset.url}`
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		// Filter out any null/undefined entries — missing data-option-value-id would produce
		// invalid IDs that could cause Shopify to ignore ?variant= and return the default variant.
		const validOptionValueIds = selectedValuesIds.filter(Boolean)

		if (currentVariantId) {
			const params = [`variant=${currentVariantId}`, `section_id=${sectionId}`]
			// Include option_values so section.settings.product_item (featured product)
			// pre-selects the correct variant — ?variant= only works for the page's implicit product.
			if (validOptionValueIds.length) {
				params.push(`option_values=${validOptionValueIds.join(',')}`)
			}
			return `${productUrl}?${params.join('&')}`
		}

		// for high-variant products: pass option_values to resolve variant server-side.
		// skip option_values for combined listing switches — the IDs belong to the
		// current product and are meaningless on the target product.
		if (validOptionValueIds.length && !combinedProductURL) {
			const params = []
			params.push(`section_id=${sectionId}`)
			params.push(`option_values=${validOptionValueIds.join(',')}`)
			return `${productUrl}?${params.join('&')}`
		}

		return `${productUrl}?section_id=${sectionId}`
	}

	setCurrentVariantAfterFetch(html) {
		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section
		const currentSectionId = this.dataset.section
		const currentBlockId = this.dataset.block
		// Fetched HTML uses original (un-prefixed) IDs; strip 'quickadd-' added by preventDuplicatedIDs.
		const sourceBlockId = currentBlockId?.replace(/^quickadd-/, '') || currentBlockId

		const sourceId = sourceBlockId
			? `variant-radios-${sourceSectionId}-${sourceBlockId}`
			: `variant-picker-${sourceSectionId}`
		const destinationId = currentBlockId
			? `variant-radios-${currentSectionId}-${currentBlockId}`
			: `variant-picker-${currentSectionId}`

		const variantPickerSource = html.getElementById(sourceId)
		const variantPickerDestination = this.resolveById(destinationId)
		if (!variantPickerSource) return

		const newVariantDataEl = variantPickerSource.querySelector(
			'[data-selected-variant]',
		)
		if (!newVariantDataEl) return

		const newVariantData = newVariantDataEl.innerHTML

		const selectedVariant = !!newVariantData ? JSON.parse(newVariantData) : null

		this.currentVariant = selectedVariant

		const oldEl = variantPickerDestination?.querySelector(
			'[data-selected-variant]',
		)
		if (oldEl) {
			oldEl.innerHTML = newVariantData
		}
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[data-all-variants-no-high]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia(mediaId) {
		if (!mediaId || !this.currentVariant?.featured_media?.id) return

		const productScope =
			this.closest('.product') || this.closest('quick-add-modal') || document

		const mediaEl = productScope.querySelector(
			`[data-section="product-media-${this.dataset.section}"]`,
		)
		if (!mediaEl) return

		const swiperWrappers = productScope.querySelectorAll(
			'.product__media-wrapper',
		)

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
				)

				const mediaList = elem.querySelector('.js-media-list')
				if (mediaList?.swiper) {
					const slideIndex = mediaList.swiper.slides.indexOf(newMedia)
					if (slideIndex >= 0) {
						mediaList.swiper.slideTo(slideIndex)
					}
				} else if (newMedia) {
					// stacked/grid galleries have no Swiper — update active class directly
					elem
						.querySelectorAll('.product__media-item')
						.forEach((item) => item.classList.remove('active'))
					newMedia.classList.add('active')
				}
			}
		})
	}

	updateURL() {
		if (this.dataset.updateUrl === 'false') return
		const newUrl = this.currentVariant
			? `${this.dataset.url}?variant=${this.currentVariant.id}`
			: this.dataset.url

		window.history.replaceState({}, '', newUrl)
	}

	updateVariantInput() {
		const sectionId = this.dataset.section
		const formIds = [
			`product-form-${sectionId}`,
			`product-form-installment-${sectionId}`,
		]
		const productForms = formIds
			.map((id) => this.resolveById(id))
			.filter(Boolean)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			if (!input) return
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', {bubbles: true}))
		})

		publish(PUB_SUB_EVENTS.variantChange, {
			data: {
				sectionId: this.dataset.section,
				variant: this.currentVariant,
			},
		})

		// [Start theme custom event] - Variant change event
		document.dispatchEvent(
			new CustomEvent('variant:change', {
				detail: {
					variant: this.currentVariant,
					previousVariant: this.previousVariant || null,
					formElement: this,
					sectionId: this.dataset.section,
				},
			}),
		)

		this.previousVariant = this.currentVariant
		// [End theme custom event] - Variant change event
	}

	getSelectedValueFromWrapper(wrapper) {
		const select = wrapper.querySelector('select')
		if (select) return select.value
		return wrapper.querySelector('input[type="radio"]:checked')?.value
	}

	updateVariantStatuses() {
		if (!this.variantData) return
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		const firstValue = this.getSelectedValueFromWrapper(inputWrappers[0])
		if (!firstValue) return
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => firstValue === variant.option1,
		)
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			]
			const previousOptionSelected = this.getSelectedValueFromWrapper(
				inputWrappers[index - 1],
			)
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			// skip options belonging to other combined-listing products
			const inputProductUrl = input.dataset?.productUrl
			if (inputProductUrl && inputProductUrl !== this.dataset.url) return

			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
					input.disabled = false
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled', 'always-clickable')
					input.disabled = false
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							'[value]',
							input.getAttribute('value'),
						)
					input.disabled = false
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')

					if (this.dataset.unavailableOptionsClickable === 'true') {
						input.classList.add('always-clickable')
						input.disabled = false
					} else {
						input.disabled = true
					}
				}
			}
		})
	}

	updatePickupAvailability() {
		// scope to the current product's container so multi-product pages don't cross-update
		const productScope =
			this.closest('quick-add-modal') ||
			this.closest('.product') ||
			document.getElementById(`shopify-section-${this.dataset.section}`) ||
			document
		const pickUpAvailability = productScope.querySelectorAll(
			'pickup-availability',
		)
		if (!pickUpAvailability.length) return

		pickUpAvailability.forEach((el) => {
			if (this.currentVariant && this.currentVariant.available) {
				el.fetchAvailability(this.currentVariant.id)
			} else {
				el.removeAttribute('available')
				el.innerHTML = ''
			}
		})
	}

	renderProductInfo(requestUrl) {
		this.abortController?.abort()
		this.abortController = new AbortController()
		fetch(requestUrl, {signal: this.abortController.signal})
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				//if (this.currentVariant.id !== requestedVariantId) return

				const html = new DOMParser().parseFromString(responseText, 'text/html')

				try {
					this.setCurrentVariantAfterFetch(html)
				} catch (err) {}

				// -----
				// for high-variant products
				// and if variant not found in liquid <script data-all-variants-no-high>
				// but it was found after a request with the option_values parameter
				if (this.isHighVariantNeedUpdate) {
					// validate: server may return a fallback variant whose options don't match
					// the user's actual selection — treat that as unavailable to prevent false add-to-cart.
					// Skip for combined listings: the switched product has different options by design.
					if (this.currentVariant && this.options?.length && !this.isCombinedListingsNeedUpdate) {
						const optionsMatch = this.options.every(
							(opt, i) =>
								opt === undefined || this.currentVariant.options[i] === opt,
						)
						if (!optionsMatch) {
							this.currentVariant = null
						}
					}
					try {
						// skip updateURL here for combined listings — URL is synced after this.dataset.url is updated below
						if (!this.isCombinedListingsNeedUpdate) this.updateURL()
						this.updatePickupAvailability()
						this.updatePickerInnerHtml(html)
						if (this.currentVariant) {
							this.updateVariantInput()
							if (
								this.currentVariant.featured_media &&
								this.dataset?.variantMediaDisplay === 'show_all' &&
								!this.isCombinedListingsNeedUpdate
							) {
								// If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch.
								// Combined listings load a different product — gallery is replaced in updateElementsAfterFetch; skip swiper on stale HTML.
								const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`
								this.updateMedia(mediaId)
							}
							//this.updateAvaliabilityNotificationInfo();
						}
					} catch (err) {}
				}
				// -----

				this.updateElementsAfterFetch(html)

				if (!this.currentVariant) {
					this.toggleAddButton(true, '')
					this.setUnavailable()
				} else {
					this.toggleAddButton(
						!this.currentVariant?.available,
						window.variantStrings.soldOut,
					)
				}
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					console.info('Fetch aborted by user')
				} else {
					console.error(error)
				}
			})
			.finally(() => {
				this.classList.remove('high-variant-loading')
			})
	}

	updatePickerInnerHtml(html) {
		// attr data-original-section use for Quick view modal
		const currentSectionId = this.dataset.section
		const currentBlockId = this.dataset.block
		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section
		const sourceBlockId = currentBlockId?.replace(/^quickadd-/, '') || currentBlockId

		const sourceId = sourceBlockId
			? `variant-radios-${sourceSectionId}-${sourceBlockId}`
			: `variant-picker-${sourceSectionId}`
		const destinationId = currentBlockId
			? `variant-radios-${currentSectionId}-${currentBlockId}`
			: `variant-picker-${currentSectionId}`

		const variantPickerSource = html.getElementById(sourceId)
		const variantPickerDestination = this.resolveById(destinationId)
		if (variantPickerSource && variantPickerDestination) {
			variantPickerDestination.innerHTML = variantPickerSource.innerHTML
		}
	}

	updateElementsAfterFetch(html) {
		const currentSectionId = this.dataset.section
		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		// price element
		const destination = this.resolveById(`price-${this.dataset.section}`)
		const source = html.getElementById(
			`price-${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)
		const skuSource = html.getElementById(
			`Sku-${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)
		const skuDestination = this.resolveById(`Sku-${this.dataset.section}`)
		const inventorySource = html.getElementById(
			`Inventory-${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)

		const inventoryDestination = this.resolveById(
			`Inventory-${this.dataset.section}`,
		)
		const colorNameSource = html.getElementById(
			`ColorName-${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`,
		)
		const colorNameDestination = this.resolveById(
			`ColorName-${this.dataset.section}`,
		)

		if (source && destination) destination.innerHTML = source.innerHTML
		if (inventorySource && inventoryDestination)
			inventoryDestination.innerHTML = inventorySource.innerHTML
		if (skuSource && skuDestination) {
			skuDestination.innerHTML = skuSource.innerHTML
			skuDestination.classList.toggle(
				'visibility-hidden',
				skuSource.classList.contains('visibility-hidden'),
			)
		} else if (!skuSource && skuDestination) {
			// variant has no SKU — clear stale value from previous variant
			skuDestination.innerHTML = ''
			skuDestination.classList.add('visibility-hidden')
		}
		if (colorNameSource && colorNameDestination) {
			colorNameDestination.innerHTML = colorNameSource.innerHTML
		} else if (!colorNameSource && colorNameDestination) {
			colorNameDestination.innerHTML = ''
		}

		// quantity rules: update from fetched response so max/min messages reset on variant switch
		const formSourceEl = html.getElementById(`product-form-${sourceSectionId}`)
		const formDestEl = this.resolveById(`product-form-${this.dataset.section}`)
		if (formDestEl) {
			const qtyRulesSource = formSourceEl?.querySelector('.quantity__rules')
			const qtyRulesDest = formDestEl.querySelector('.quantity__rules')
			if (qtyRulesDest) {
				qtyRulesDest.innerHTML = qtyRulesSource ? qtyRulesSource.innerHTML : ''
			}
			const qtyInputSource = formSourceEl?.querySelector('.quantity__input')
			const qtyInputDest = formDestEl.querySelector('.quantity__input')
			if (qtyInputSource && qtyInputDest) {
				;[
					'data-min',
					'min',
					'data-max',
					'max',
					'step',
					'data-cart-quantity',
				].forEach((attr) => {
					const val = qtyInputSource.getAttribute(attr)
					if (val !== null) qtyInputDest.setAttribute(attr, val)
					else qtyInputDest.removeAttribute(attr)
				})
				qtyInputDest.value = qtyInputSource.value
			}

			// clear any cart error message so stale messages don't persist after variant change
			const productFormEl = formDestEl.closest('product-form')
			if (productFormEl) {
				productFormEl.handleErrorMessage?.()
			} else {
				formDestEl
					.querySelector('.product-form__error-message-wrapper')
					?.setAttribute('hidden', '')
			}
		}

		const price = this.resolveById(`price-${this.dataset.section}`)

		if (price) price.classList.remove('visibility-hidden')

		if (inventoryDestination)
			inventoryDestination.classList.toggle(
				'visibility-hidden',
				inventorySource?.innerText === '',
			)

		this.toggleAddButton(
			!this.currentVariant?.available,
			window.variantStrings.soldOut,
		)

		// Quick view: always swap gallery from fetch (Swiper + DOM ids are modal-specific; slideTo alone is unreliable).
		// Combined listings fetch another product URL — always refresh gallery from the response (same as non-show_all).
		const inQuickView = Boolean(this.closest('quick-add-modal'))
		if (
			inQuickView ||
			this.dataset?.variantMediaDisplay !== 'show_all' ||
			this.isCombinedListingsNeedUpdate
		) {
			const parentQuickView = this.closest('quick-add-modal')
			const galleryScope = parentQuickView || document

			// Use .product__media-wrapper as boundary — it is always present inside
			// [data-section="main-X"] for all gallery types (slider, stacked, grid)
			// AND for no-media products (placeholder SVG). Replacing its innerHTML
			// covers every case: media→media, media→no-media, no-media→media.
			const mediaWrapperSource = html.querySelector(
				`[data-section="main-${sourceSectionId}"] .product__media-wrapper`,
			)
			const mediaWrapperDest = galleryScope.querySelector(
				`[data-section="main-${currentSectionId}"] .product__media-wrapper`,
			)

			if (mediaWrapperDest) {
				// destroy any running Swiper instances before replacing DOM
				const sliderRestartRoot =
					mediaWrapperDest.closest('.product') || parentQuickView
				if (sliderRestartRoot) {
					sliderRestartRoot
						.querySelectorAll('.js-media-list')
						.forEach((el) => el.swiper?.destroy(true, true))
					sliderRestartRoot
						.querySelectorAll('.js-media-sublist')
						.forEach((el) => el.swiper?.destroy(true, true))
				}

				// replace entire wrapper — includes gallery, thumbnails, placeholder, or empty
				mediaWrapperDest.innerHTML = mediaWrapperSource
					? mediaWrapperSource.innerHTML
					: ''

				// update zoom modal — product-media-modal moves to document.body so always
				// use document.querySelector regardless of quick-view context
				const popupSliderEl = document.querySelector('.js-popup-slider')
				if (popupSliderEl) {
					const popupSwiperWrapper =
						popupSliderEl.querySelector('.swiper-wrapper')
					const popupSwiperSource = html.querySelector(
						'.js-popup-slider .swiper-wrapper',
					)
					if (popupSwiperWrapper) {
						popupSliderEl.swiper?.destroy(true, true)
						popupSwiperWrapper.innerHTML = popupSwiperSource
							? popupSwiperSource.innerHTML
							: ''
					}
				}

				if (parentQuickView) {
					// quick-add-modal opens with delay 8; match that after DOM swap
					if (mediaWrapperDest.querySelector('.js-media-list')) {
						subSliderInit(true, 8, mediaWrapperDest)
						sliderInit(true, mediaWrapperDest)
					}
				} else {
					if (mediaWrapperDest.querySelector('.js-media-list')) {
						subSliderInit(true, 16, mediaWrapperDest)
						sliderInit(true, mediaWrapperDest)
					}
					if (mediaWrapperSource && typeof popupSliderInit === 'function') {
						popupSliderInit(true)
					}
				}
			}
		}

		if (this.isCombinedListingsNeedUpdate) {
			const scope = this.getVariantDomScope()
			const sectionId = this.dataset.section

			// --- Replace entire product info container from fetched HTML ---
			// ProductInfo-X holds all blocks: title, description, variant picker,
			// custom liquid, complementary products, etc.
			// We replace its innerHTML (with section ID fixup) so every block
			// reflects the switched product without needing per-block selectors.
			const infoContainerSource = html.getElementById(
				`ProductInfo-${sourceSectionId}`,
			)
			const infoContainerDest = this.resolveById(`ProductInfo-${sectionId}`)

			if (infoContainerSource) {
				if (inQuickView) {
					// In QV: patch only the picker innerHTML in place.
					// Never replace ProductInfo-X.innerHTML — that would wipe the
					// "View details" link and any other static QV elements.
					const newPickerSource =
						infoContainerSource.querySelector('variant-radios') ||
						infoContainerSource.querySelector('variant-selects')
					if (newPickerSource) {
						this.innerHTML = newPickerSource.innerHTML.replaceAll(
							sourceSectionId,
							sectionId,
						)
					}

					// Update product title in QV when switching combined listing products.
					const titleSource = html.getElementById(
						`ProductTitle-${sourceSectionId}`,
					)
					const titleDest = this.resolveById(`ProductTitle-${sectionId}`)
					if (titleSource && titleDest) {
						titleDest.innerHTML = titleSource.innerHTML
					}
				} else if (infoContainerDest) {
					// On the product page: replace the entire info container so
					// title, description, and all blocks reflect the switched product.
					const newHtml = infoContainerSource.innerHTML.replaceAll(
						sourceSectionId,
						sectionId,
					)
					infoContainerDest.innerHTML = newHtml

					// Re-insert `this` (the live picker element) in place of the
					// freshly-rendered (non-functional) one so event listeners survive.
					const newPickerEl =
						infoContainerDest.querySelector('variant-radios') ||
						infoContainerDest.querySelector('variant-selects')
					if (newPickerEl && newPickerEl !== this) {
						this.innerHTML = newPickerEl.innerHTML
						newPickerEl.replaceWith(this)
					}
				}
			}

			// --- Breadcrumb (outside ProductInfo container) ---
			const breadcrumbSource = html.getElementById(
				`ProductBreadcrumbTitle-${sourceSectionId}`,
			)
			const breadcrumbDest = this.resolveById(
				`ProductBreadcrumbTitle-${sectionId}`,
			)
			if (breadcrumbSource && breadcrumbDest) {
				breadcrumbDest.innerText = breadcrumbSource.innerText
			}

			// --- Complementary products: update data-url with new product ID and re-fetch ---
			// product-recommendations fetches once on intersection; after a product
			// switch we need to request recommendations for the switched product.
			const complementarySource = html.querySelector('.complementary-products')
			const complementaryDest = scope.querySelector('.complementary-products')
			if (complementarySource && complementaryDest) {
				const newUrl = complementarySource.dataset.url
				if (newUrl) {
					complementaryDest.dataset.url = newUrl
					// Re-fetch with the new product ID
					fetch(newUrl)
						.then((r) => r.text())
						.then((text) => {
							const complementaryHtml = new DOMParser().parseFromString(
								text,
								'text/html',
							)
							const newRecommendations = complementaryHtml.querySelector(
								'product-recommendations',
							)
							if (newRecommendations?.innerHTML.trim()) {
								complementaryDest.innerHTML = newRecommendations.innerHTML
							} else {
								complementaryDest.innerHTML = ''
							}
						})
						.catch(() => {})
				}
			}

			// --- Sync variant picker state on `this` ---
			// After innerHTML replacement, variantData cache is stale.
			this.variantData = null

			// Sync base URL so subsequent variant changes fetch from the switched product.
			// Search broadly — featured-product has no .product__info-wrapper wrapper.
			const variantsSource =
				html.querySelector('variant-radios[data-url]') ||
				html.querySelector('variant-selects[data-url]')
			const newProductUrl = variantsSource?.dataset?.url
			if (newProductUrl) {
				this.dataset.url = newProductUrl
			}
			// Sync high-variant flag from the incoming product so subsequent
			// option changes on the new product use server-side variant resolution.
			if (variantsSource?.dataset?.isHighVariantProduct !== undefined) {
				this.dataset.isHighVariantProduct =
					variantsSource.dataset.isHighVariantProduct
			}

			// Re-read options from the newly swapped-in picker so the first
			// subsequent variant change reads the correct option values.
			this.updateOptions()

			// Update page URL now that this.dataset.url reflects the switched product.
			this.updateURL()
		}
	}

	toggleAddButton(disable = true, text) {
		const productForm = this.resolveProductFormEl()
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		if (!addButton) return
		const addButtonText =
			addButton.querySelector('.button__label') ||
			addButton.querySelector('span')

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}
	}

	setUnavailable() {
		const button = this.resolveProductFormEl()
		const addButton = button?.querySelector('[name="add"]')
		const price = this.resolveById(`price-${this.dataset.section}`)
		const inventory = this.resolveById(`Inventory-${this.dataset.section}`)
		const sku = this.resolveById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	getVariantDomScope() {
		return this.closest('quick-add-modal') || document
	}

	resolveProductFormEl() {
		const id = `product-form-${this.dataset.section}`
		const modal = this.closest('quick-add-modal')
		//if (modal) {
		//	return (
		//		Array.from(modal.querySelectorAll('[id]')).find((el) => el.id === id) ||
		//		null
		//	)
		//}
		return document.getElementById(id)
	}

	resolveById(id) {
		const modal = this.closest('quick-add-modal')
		if (modal) {
			return (
				Array.from(modal.querySelectorAll('[id]')).find((el) => el.id === id) ||
				null
			)
		}
		return document.getElementById(id)
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[data-all-variants-no-high]').textContent)
		return this.variantData
	}
}

if (!customElements.get('variant-selects')) {
	customElements.define('variant-selects', VariantSelects)
}

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			// skip options belonging to other combined-listing products
			const inputProductUrl = input.dataset?.productUrl
			if (inputProductUrl && inputProductUrl !== this.dataset.url) return

			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled', 'always-clickable')
				input.disabled = false
			} else {
				input.classList.add('disabled')

				if (this.dataset.unavailableOptionsClickable === 'true') {
					input.classList.add('always-clickable')
					input.disabled = false
				} else {
					input.disabled = true
				}
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked,
			)?.value
		})
	}
}

customElements.define('variant-radios', VariantRadios)

class VariantDropdownSelect extends HTMLElement {
	constructor() {
		super()
		this.currentEl = this.querySelector('.dropdown-select__current')
		this.optionsWrapperEl = this.querySelector('.dropdown-select__options')
		this.hiddenInput = this.querySelector("input[type='hidden']")

		if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) return

		this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll('li'))
		this.inputs = Array.from(this.optionsWrapperEl.querySelectorAll('input'))
		this.hasColorSwatch = this.currentEl?.classList?.contains(
			'dropdown-select__current--with-color',
		)
		this.isActive = false

		this.optionPosition = this.getOptionPosition()
		this._onCurrentClick = this.onCurrentClick.bind(this)
		this._onKeyUp = this.onKeyUp.bind(this)
		this._onOptionsClick = this.onClickOption.bind(this)
		this._onKeyUpOptions = this.onKeyUpOptions.bind(this)
		this._onOutsideClick = this.onOutsideClick.bind(this)
	}

	connectedCallback() {
		this.currentEl.addEventListener('click', this._onCurrentClick)
		this.currentEl.addEventListener('keyup', this._onKeyUp)
		this.currentEl.addEventListener('dblclick', this.preventDoubleClick)
		this.optionsWrapperEl.addEventListener('click', this._onOptionsClick)
		this.optionsWrapperEl.addEventListener('keyup', this._onKeyUpOptions)
		document.addEventListener('click', this._onOutsideClick)
	}

	disconnectedCallback() {
		this.currentEl.removeEventListener('click', this._onCurrentClick)
		this.currentEl.removeEventListener('keyup', this._onKeyUp)
		this.currentEl.removeEventListener('dblclick', this.preventDoubleClick)
		this.optionsWrapperEl.removeEventListener('click', this._onOptionsClick)
		this.optionsWrapperEl.removeEventListener('keyup', this._onKeyUpOptions)
		document.removeEventListener('click', this._onOutsideClick)
	}

	onCurrentClick(event) {
		event.stopPropagation()
		if (this.isActive) {
			this.onClose()
		} else {
			this.onOpen()
		}
	}

	onKeyUp(event) {
		if (event.code?.toUpperCase() === 'ENTER') {
			event.preventDefault()
			event.stopPropagation()
			if (this.isActive) {
				this.onClose()
			} else {
				this.onOpen()
			}
		}
	}

	preventDoubleClick(event) {
		event.preventDefault()
		event.stopPropagation()
	}

	onClickOption(event) {
		const optionEl = event.target.closest('li')
		const currentValueEl = this.currentEl.querySelector(
			'[data-dropdown-current-value]',
		)

		if (
			!optionEl ||
			!currentValueEl ||
			!this.optionsWrapperEl.contains(optionEl)
		) {
			event.preventDefault()
			return
		}

		const optionInput = optionEl.querySelector('input[type="radio"]')
		if (
			optionInput &&
			optionInput.disabled &&
			!optionInput.classList.contains('always-clickable') &&
			!optionInput.dataset?.productUrl
		) {
			event.preventDefault()
			return
		}

		const newValue = optionEl.dataset.value
		//const selectedProductUrl = optionInput?.dataset?.productUrl

		currentValueEl.textContent = newValue
		this.hiddenInput.value = newValue
		//if (selectedProductUrl) {
		//	this.hiddenInput.dataset.productUrl = selectedProductUrl
		//}

		if (this.hasColorSwatch) {
			const newColor = optionEl.dataset.color
			this.hiddenInput.dataset.colorSwatch = newColor
			this.currentEl.style.setProperty('--swatch-color', newColor)
		}

		this.inputs.forEach((el) => {
			el.checked = false
			el.removeAttribute('checked')
		})
		if (optionInput) {
			optionInput.checked = true
			optionInput.setAttribute('checked', 'true')
		}

		const changeTarget = optionInput || this.hiddenInput
		changeTarget.dispatchEvent(new Event('change', {bubbles: true}))

		this.onClose()
		this.currentEl.focus()
	}

	onKeyUpOptions(event) {
		if (event.code === 'Escape' && this.isActive) {
			event.preventDefault()
			this.onClose()
			this.currentEl.focus()
		}
	}

	onOpen() {
		document.querySelectorAll('variant-dropdown-select').forEach((dropdown) => {
			if (dropdown !== this && typeof dropdown.onClose === 'function') {
				dropdown.onClose()
			}
		})

		this.optionsWrapperEl.classList.add('active')
		this.currentEl.setAttribute('aria-expanded', 'true')
		this.isActive = true

		const currentIndex = this.inputs.findIndex((inp) =>
			inp.hasAttribute('checked'),
		)
		this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus()
	}

	onClose() {
		this.optionsWrapperEl.classList.remove('active')
		this.currentEl.setAttribute('aria-expanded', 'false')
		this.isActive = false
	}

	onOutsideClick(event) {
		if (!this.isActive || this.contains(event.target)) return
		this.onClose()
	}

	getOptionPosition() {
		const parentFieldset = this.closest('.product-form__controls')
		return Number(parentFieldset?.dataset?.optionPosition || -1)
	}

	updateCurrentOption(selectedValues = []) {
		// Method is used to synchronize after changes options in sticky bar.
		if (this.optionPosition === -1) return
		const currentValueEl = this.currentEl.querySelector(
			'[data-dropdown-current-value]',
		)

		if (!currentValueEl || !selectedValues || !selectedValues.length) return

		const newValue = selectedValues[this.optionPosition - 1]

		currentValueEl.textContent = newValue
		this.hiddenInput.value = newValue

		this.optionsEls.forEach((optionEl) => {
			const liDataValue = optionEl.dataset.value
			if (newValue === liDataValue && this.hasColorSwatch) {
				const newColor = optionEl.dataset.color
				this.hiddenInput.dataset.colorSwatch = newColor
				this.currentEl.style.setProperty('--swatch-color', newColor)
			}
		})
	}
}

if (!customElements.get('variant-dropdown-select')) {
	customElements.define('variant-dropdown-select', VariantDropdownSelect)
}

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image['src'])
						return widths
							.filter((width) => width <= image['width'])
							.map((width) => {
								imageUrl.searchParams.set('width', width.toString())
								return `${imageUrl.href} ${width}w`
							})
							.join(', ')
					}

					const createImageElement = (image, classes, sizes, productTitle) => {
						const previewImage = image['preview_image']
						const newImage = new Image(
							previewImage['width'],
							previewImage['height'],
						)
						newImage.className = classes
						newImage.alt = image['alt'] || productTitle
						newImage.sizes = sizes
						newImage.src = previewImage['src']
						newImage.srcset = generateSrcset(
							previewImage,
							[165, 360, 533, 720, 940, 1066],
						)
						newImage.loading = 'lazy'
						return newImage
					}

					const checkSwatches = () => {
						document
							.querySelectorAll('.js-color-swatches-wrapper')
							.forEach((wrapper) => {
								wrapper
									.querySelectorAll('.js-color-swatches input')
									.forEach((input) => {
										input.addEventListener('click', (event) => {
											const primaryImage =
												wrapper.querySelector('.media--first')
											const secondaryImage =
												wrapper.querySelector('.media--second')
											const handleProduct = wrapper.dataset.product

											if (event.currentTarget.checked && primaryImage) {
												wrapper
													.querySelector('.js-color-swatches-link')
													.setAttribute(
														'href',
														event.currentTarget.dataset.variantLink,
													)
												const currentColor = event.currentTarget.value

												jQuery.getJSON(
													window.Shopify.routes.root +
														`products/${handleProduct}.js`,
													function (product) {
														const variant = product.variants.filter(
															(item) =>
																item.featured_media != null &&
																item.options.includes(currentColor),
														)[0]

														if (variant) {
															const newPrimaryImage = createImageElement(
																variant['featured_media'],
																primaryImage.className,
																primaryImage.sizes,
																product.title,
															)

															if (newPrimaryImage.src !== primaryImage.src) {
																let flag = false
																if (secondaryImage) {
																	const secondaryImagePathname = new URL(
																		secondaryImage.src,
																	).pathname
																	const newPrimaryImagePathname = new URL(
																		newPrimaryImage.src,
																	).pathname

																	if (
																		secondaryImagePathname ==
																		newPrimaryImagePathname
																	) {
																		primaryImage.remove()
																		secondaryImage.classList.remove(
																			'media--second',
																		)
																		secondaryImage.classList.add('media--first')
																		flag = true
																	}
																}
																if (flag == false) {
																	primaryImage.animate(
																		{opacity: [1, 0]},
																		{
																			duration: 200,
																			easing: 'ease-in',
																			fill: 'forwards',
																		},
																	).finished
																	setTimeout(function () {
																		primaryImage.replaceWith(newPrimaryImage)
																		newPrimaryImage.animate(
																			{opacity: [0, 1]},
																			{duration: 200, easing: 'ease-in'},
																		)
																		if (secondaryImage) {
																			secondaryImage.remove()
																		}
																	}, 200)
																}
															}
														}
													},
												)
											}
										})
									})
							})
					}

					checkSwatches()

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll('.card__inner')
						let top = 0

						if (imageWrapper) {
							top = imageWrapper[0]?.offsetHeight / 2
						} else {
							top = 50
						}

						return top
					}

					const initSlider = () => {
						let mobileLayout = 1
						if (this.dataset.mobileLayout) {
							mobileLayout = this.dataset.mobileLayout
						}
						let slider = new Swiper(
							this.querySelector('.js-recommendation-swiper'),
							{
								slidesPerView: mobileLayout,
								mousewheel: {
									forceToAxis: true,
								},
								slidesPerGroup: 1,
								spaceBetween: 8,
								speed: 500,
								navigation: {
									nextEl: this.querySelector(
										'.product-recommendations__slider-nav .swiper-button-next',
									),
									prevEl: this.querySelector(
										'.product-recommendations__slider-nav .swiper-button-prev',
									),
								},
								breakpoints: {
									576: {
										slidesPerView: 2,
										slidesPerGroup: 2,
									},
									750: {
										slidesPerView: 3,
										slidesPerGroup: 3,
										spaceBetween: 24,
									},
								},
							},
						)
					}

					const initSection = () => {
						const section = this

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							let top = calcTop(section)
							if (section.querySelector('.product-recommendations__slider-nav'))
								section.querySelector(
									'.product-recommendations__slider-nav',
								).style.top = top + 'px'
						})

						sectionResizeObserver.observe(section)

						initSlider()
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations)
;(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector(
				'.section--has-overlay',
			)
			const headerGroupSections = document.querySelectorAll(
				'.shopify-section-group-header-group',
			)
			const header = document.querySelector('.shopify-section-header')

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains('section--has-overlay')) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove('not-margin')

						if (sectionFirstChild.classList.contains('section--header-light')) {
							header.classList.add('color-background-overlay')
						} else {
							header.classList.remove('color-background-overlay')
						}
					} else {
						sections[0].classList.add('not-margin')
						header.classList.remove('color-background-overlay')
					}
				} else {
					sections[0].classList.remove('not-margin')

					header.classList.remove('color-background-overlay')
				}
			} else {
				header.classList.remove('color-background-overlay')
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', initHeaderOverlay)
	document.addEventListener('shopify:section:unload', initHeaderOverlay)
	document.addEventListener('shopify:section:reorder', initHeaderOverlay)
})()

function formatMoney(cents, format = '') {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '')
	}
	cents = parseInt(cents, 10)
	let value = ''

	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.moneyFormat

	function formatWithDelimiters(
		number,
		precision = 2,
		thousands = ',',
		decimal = '.',
	) {
		if (isNaN(number) || number == null) {
			return '0'
		}

		number = (number / 100.0).toFixed(precision)

		const parts = number.split('.')
		const dollarsAmount = parts[0].replace(
			/(\d)(?=(\d{3})+(?!\d))/g,
			`$1${thousands}`,
		)
		const centsAmount = precision > 0 ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	const match = formatString.match(placeholderRegex)
	const formatType = match ? match[1] : 'amount'

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.')
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.')
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.')
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.')
	}
	return formatString.replace(placeholderRegex, value)
}

const initUnderlinedTitles = () => {
	let sectionTitles = document.querySelectorAll(
		'.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group) .title--rounded',
	)

	if (sectionTitles.length > 0) {
		sectionTitles.forEach((title) => {
			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				let xs, s, m, l, xl

				if (document.body.clientWidth < 1600) {
					xs = 95
					s = 160
					m = 280
					l = 380
					xl = 520
				} else {
					xs = 95
					s = 200
					m = 360
					l = 450
					xl = 620
				}

				entry.target
					.querySelectorAll('span[style="text-decoration:underline"]')
					.forEach((span) => {
						const titleWidth = span.getBoundingClientRect().width
						span.classList.remove(
							'title--rounded-xs',
							'title--rounded-s',
							'title--rounded-m',
							'title--rounded-l',
							'title--rounded-xl',
							'title--rounded-xxl',
						)
						if (titleWidth < xs) {
							span.classList.add('title--rounded-xs')
						} else if (titleWidth < s) {
							span.classList.add('title--rounded-s')
						} else if (titleWidth < m) {
							span.classList.add('title--rounded-m')
						} else if (titleWidth < l) {
							span.classList.add('title--rounded-l')
						} else if (titleWidth < xl) {
							span.classList.add('title--rounded-xl')
						} else {
							span.classList.add('title--rounded-xxl')
						}
					})
			})

			sectionResizeObserver.observe(title)
		})
	}
}

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener('cart:refresh', () => {
	const sectionsToUpdate = [
		{id: 'cart-icon-bubble', selector: '#cart-icon-bubble'},
		{id: 'cart-drawer', selector: 'cart-drawer'},
		{id: 'main-cart-items', selector: '#main-cart-items'},
		{id: 'main-cart-footer', selector: '#main-cart-footer'},
		{id: 'main-cart-shipping', selector: '.cart-shipping'},
	]
	sectionsToUpdate.forEach((section) => {
		fetch(`${routes.cart_url}?section_id=${section.id}`)
			.then((response) => response.text())
			.then((html) => {
				const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
				const source = parsedHTML.querySelector(section.selector)
				const target = document.querySelector(section.selector)
				if (source && target) {
					target.innerHTML = source.innerHTML
				}
			})
			.catch((e) =>
				console.error(`[cart:refresh] error updating ${section.id}`, e),
			)
	})
})

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------
